// import { useState } from "react";
import AuthContext from '../../Context/AuthProvider';
import { useRef, useState, useEffect ,useContext} from 'react';
import {Link,useLocation, useNavigate } from "react-router";
// import useAuth from '../hooks/useAuth';
// const from = location.state?.from?.pathname || "/";
import "./Login.css"
// import useAuth from "../../Hooks/UseAuth";
// import useAuth from "../../Hooks/useRefreshToken"
import useAuth from '../../Hooks/UseAuth';

// import ClipLoader from "react-spinners/ClipLoader";
import BeatLoader from "react-spinners/BeatLoader";
// import axios from '../api/axios';
import axios from '../../api/axios';
import img1 from "../../Images/BLACK.png"
const LOGIN_URL = '/auth';





// import { Link, useNavigate, useLocation } from 'react-router-dom';

// import { Link,useLocation,useNavigate } from "react-router-dom";

function Login(){  
    
    let navigate = useNavigate();
    // let navigate = useNavigate();
    let location = useLocation();
    // let location = useLocation();
	const [email, setEmail] = useState('');
    const [name, setName] = useState('')
	const [password, setPassword] = useState(''); 
	// const [password, setPassword] = useState('nerd1234'); 
    // const {setAuth, auth} = useAuth()
    const { setAuth,auth } = useContext(AuthContext);
    const [signUp, setSignup] = useState(false); 
    const [loginState, setLogin] = useState(true); 
    const [register, setRegister] = useState(false);
    const [Branch, setBranch] = useState("");
    const [Phone, setPhone] = useState("");
    const [AccNo, setAccNo] = useState("");
    const [Loading, setLoading] = useState(false);
    const [errorMsg, setErrorMsg] = useState(false);
    const [Msg, setMsg] = useState("");
    const [successMsg, setSuccessMsg] = useState(false);
    const userRef = useRef();
    const errRef = useRef();
    const [OrgName, setOrgName] = useState("");
    const [forgotPwdState, setForgotPwdStaten] = useState(false); 
    const [sucessRecovery, setSucessRecovery] = useState(false); 


    const [user, setUser] = useState('');
    const [pwd, setPwd] = useState('');
    const [errMsg, setErrMsg] = useState('')

    //
   
	// const [email, setEmail] = useState('')
	// const [password, setPassword] = useState('') 


    
    
   
    
    async function LoginUser(e) {  
        e.preventDefault();  
        setLoading(true)
        setSuccessMsg(false);
        setErrorMsg(false);
       
        // const from = location?.state?.from?.pathname || "/UserDash";

         const response = await fetch("http://localhost:2001/api/authlogin",{ 
        //  const response = await fetch("https://superagentback.onrender.com/api/login",{ 
                method : "POST", 
                headers: { 
                 "content-type" :   "application/json"
                }, 
                body: JSON.stringify({
                    email,
                    password
                })
                

         }) 
 
         const data = await response.json();
         console.log(data,"data")
        //  if(data==undefined){
            
        //  }
         if(data.status== "ok"){ 
            setLoading(false)
            console.log("Data",data);
            // console.log("Data",data.data);
            // var authData = data.data;
            // localStorage.setItem('tokem',data.user);
            setAuth({user: email, roles : [data.data.role,"test role"], dat : data.data});
            console.log("Email" ,email, "Role",data.data.role);
            console.log("AUth",auth.user)
            alert("login successful!");
            // navigate("/dashboard");
            // navigate(from,{replace: true});
         } else{ 
            // alert("Unauthorized access") 
            setLoading(false);
            setMsg(data.msg)
            setErrorMsg(true);

         }
         
    }

    

    const handleAuthForm = () =>{
          
          setLogin(!loginState); 
          setRegister(!register);
          setForgotPwdStaten(false)
          
    }
    

    const handleAuthFormSec = () =>{
          
          setLogin(false); 
          setRegister(!register);
          setForgotPwdStaten(false)
          
    }
    
  const handleFOrgotPwd = () =>{
        setForgotPwdStaten(true)
        setLogin(false); 
        setRegister(false);
        
  }

    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true)
        setSuccessMsg(false);
        setErrorMsg(false);

        try {
            console.log("email",email,"and",password)
            const response = await axios.post(LOGIN_URL,
                JSON.stringify({ email, password }),
                // JSON.stringify({ user, pwd }),
                {
                    headers: { 'Content-Type': 'application/json',
                    // 'Origin': 'https://www.google.com/'
                    // 'Origin': 'http://localhost:3000'
                 },
                    
                    withCredentials: true,
                    crossDomain: true,
//   headers: {
//     'Origin': 'http://localhost:3000'
//   }
                    
                }
            );

            console.log(response)

            if(response?.data.status== "ok"){
            // if(response?.data?.accessToken !=""){
            // if(response?.data){

                // console.log("whole",JSON.stringify(response?.data));
                console.log(JSON.stringify(response));
                const user = response?.data?.email;
                const accessToken = response?.data?.accessToken;
                const roles = response?.data?.roles;
                const foundUser = response?.data?.foundUser;
                const foundOrg = response?.data?.foundOrg;
                setAuth({});
                setAuth({ user, roles : [roles,"test role"], accessToken, foundUser,foundOrg});
                // setAuth({});
                // setAuth({ user, pwd, roles, accessToken });
                console.log("autheeeeee",auth)
                setUser('');
                setPwd('');
                navigate("/Dashboard");

            }
            else {
                console.log("test true")
                setLoading(false);
                setMsg(response.data.msg)
                setErrorMsg(true);

            }
            
            // navigate(from, { replace: true });
        } catch (err) {
            // if (!err?.response) {
            //     setErrMsg('No Server Response');
            // } else if (err.response?.status === 400) {
            //     setErrMsg('Missing Username or Password');
            // } else if (err.response?.status === 401) {
            //     setErrMsg('Unauthorized');
            // } else {
            //     setErrMsg('Login Failed');
            // }
            // // errRef.current.focus();
        }
    }

       ///Handle forgot submit
       const fgtPwdHandler = async (e) => {
        // e.preventDefault();
        e.preventDefault();  
        setLoading(true)
        setSuccessMsg(false);
        setErrorMsg(false);
       
        const from = location?.state?.from?.pathname || "/UserDash";

        try {
            // console.log("email",email,"and",password)
            const response = await axios.post(LOGIN_URL+"/UsrRecovery",
                JSON.stringify({ email, password }),
                // JSON.stringify({ user, pwd }),
                {
                    headers: { 'Content-Type': 'application/json',
                    // 'Access-Control-Allow-Credentials': 'true' ,
                    // 'Origin': 'https://www.google.com/'
                    // 'Origin': 'http://localhost:3000',
                    'x-client-host': window.location.hostname
                 },
                    
                    withCredentials: true,
                    crossDomain: true,
          
                }
            );
            console.log("found ddagagdaorg")
            if(response?.data?.accessToken !=""){

                setForgotPwdStaten(false)
                setSucessRecovery(true)

                // console.log("whole",JSON.stringify(response?.data));
                console.log(JSON.stringify(response));
                const user = response?.data?.email;
                const accessToken = response?.data?.accessToken;
                const roles = response?.data?.roles;
                const foundUser = response?.data?.foundUser;
                const foundOrg = response?.data?.foundOrg;
                console.log("found org",foundOrg)
                setAuth({});
                setAuth({ user, roles : [roles,"test role"], accessToken, foundUser, foundOrg});
                // setAuth({ user, pwd, roles, accessToken });
                console.log("autheeeeee",auth)
                setLoading(false)
           
            // alert("login successful!");
            // navigate("/dashboard");
            // navigate(from,{replace: true});

            }
            
            // navigate(from, { replace: true });
        } catch (err) {
           
        }
    }

    async function registerUser(e) {  
        e.preventDefault(); 
        setLoading(true);
        setSuccessMsg(false);
        setErrorMsg(false);
        

        //  const response = await fetch("https://superagentback.onrender.com/api/register",{ 
        //  const response = await fetch("http://localhost:2001/api/authregister",{ 
         const response = await fetch("https://nerdayb.onrender.com/Org",{ 
        //  const response = await fetch("http://localhost:2001/Org",{ 
             
                method : "POST",
                headers: { 
                 "content-type" :   "application/json",
                 'Access-Control-Allow-Credentials': true
                }, 

                credentials: 'include'
                ,
                body: JSON.stringify({
                    // name,
                    // email,
                    // password,
                    // AccNo,
                    // Branch,       
                    name,
                    email,
                    password,
                    AccNo,
                    Branch,
                    OrgName,
                    Phone

                }),
                

            
                

         }) 

         const data = await response.json();
         console.log(data);

            // if(data==undefined){
                
            // }

          if(data.status == 'Ok'){
            // navigate("/login");
            setLoading(false);
            setSuccessMsg(true)
            setMsg(data.msg)
            
            handleAuthForm()
          }else{
            // alert("Operation Failed")
            setLoading(false);
            setMsg(data.msg)
            setErrorMsg(true);
          }
    }

    


    return( 

        <>  
            <div className="center">
                {loginState &&<>

                    {/* <h1>Login</h1> */}
                    <div className='formLogo'>
                        <img src={img1} />
                    </div>
                        {/* <form onSubmit={LoginUser}> */}
                        <form onSubmit={handleSubmit}>
                            <div className="txt_field">
                            <input
                                value={email}
                                onChange={(e) => setEmail(e.target.value)}
                                type="email"
                                // placeholder="Email"
                                required
                            />
                            <span></span>
                            <label>Email</label>

                            </div>
                            <div  className="txt_field">

                                    <input
                                            value={password}
                                            onChange={(e) => setPassword(e.target.value)}
                                            type="password"
                                            // placeholder="Password"
                                            required
                                        />

                                    <span></span>
                                    <label>Password</label>

                            </div>

                            
                                
                           {/* Loading Animation */}
                            {Loading ?
                            <div>
                                <BeatLoader color="#36d7b7" />
                              
                            </div> :  
                                <>
                                     <input type="submit" value="Login" />
                                     {errorMsg && <div className="errorMsgContainer">
                                            
                                            <p>{`Operation Failed! ${Msg}`}</p>
                                            
                                 </div>}
                                        <div className="signup_link">
                                        Not a member? <a href="#" onClick={handleAuthForm}>Signup</a>
                                    </div>
                                    <div className="signup_link">
                                          <a href="#" onClick={handleFOrgotPwd}>Forgot your password?</a>
                                    </div>

                                </>   
                             
                             } 

                           
                           
                        </form>

                </>}
                      {forgotPwdState &&<>

                    <h1>Account Recovery</h1>
                        <form onSubmit={fgtPwdHandler}>
                            <div className="txt_field">
                            <input
                                value={email}
                                onChange={(e) => setEmail(e.target.value)}
                                type="email"
                                // placeholder="Email"
                                required
                            />
                            <span></span>
                            <label>Email</label>

                            </div>
                                
                           {/* Loading Animation */}
                            {Loading ?
                            <div>
                                <BeatLoader color="#36d7b7" />
                              
                            </div> :  
                                <>
                                     <input type="submit" value="Submit" />
                                     {errorMsg && <div className="errorMsgContainer">
                                            
                                            <p>{`Operation Failed! ${Msg}`}</p>
                                            
                                 </div>}
                                        <div className="signup_link">
                                        Not Registered? <a href="#" onClick={handleAuthFormSec}>Signup</a>
                                    </div>

                                </>   
                             
                             } 

                           
                           
                        </form>

                </>}


                      {sucessRecovery &&<>

                    <h1>Account Recovery</h1>
                        {/* <form onSubmit={fgtPwdHandler}> */}

                      <p> We have sent you a mail to reset your <b>NERDAY</b> password.</p> 

                      {/* <p>Click the Reset Password in that mail.</p>  */}

                      <p>If you didn't receive the reset password mail, please check the promotion/spam folder.</p> 
                         
                           
                           
                        {/* </form> */}

                </>}
                 {register &&<>

                    {/* <h1>Register</h1> */}
                    <div className='formLogo'>
                        <img src={img1} />
                    </div>
                        <form onSubmit={registerUser}>
                            {/* Name */}
                            <div className="txt_field">
                            <input
                                value={name}
                                onChange={(e) => setName(e.target.value)}
                                type="text"
                                required
                            />
                            <span></span>
                            <label>Name</label>

                            </div>

                            {/* Email */}
                            <div className="txt_field">
                            <input
                                value={email}
                                onChange={(e) => setEmail(e.target.value)}
                                type="email"
                                required
                            />
                            <span></span>
                            <label>Email</label>

                            </div>
                            {/* AccountNumber */}
                            <div className="txt_field">
                            <input
                                value={AccNo}
                                onChange={(e) => setAccNo(e.target.value)}
                                type="text"
                                required
                            />
                            <span></span>
                            <label>Account Number</label>

                            </div>

                            {/* Branch */}
                            <div className="txt_field">
                            <input
                                value={Branch}
                                onChange={(e) => setBranch(e.target.value)}
                                type="text"
                                required
                            />
                            <span></span>
                            <label>Your HQ</label>

                            </div>
                            {/* Email */}
                            <div className="txt_field">
                        <input
                            value={OrgName}
                            onChange={(e) => setOrgName(e.target.value)}
                            type="text"
                            required
                        />
                        <span></span>
                        <label>Company Name</label>

                            </div>
                            {/* Phonenumber */}
                            <div className="txt_field">
                        <input
                            value={Phone}
                            onChange={(e) => setPhone(e.target.value)}
                            type="text"
                            required
                        />
                        <span></span>
                        <label>Phone Number</label>

                            </div>
                            {/* Password */}
                            <div className="txt_field">
                        <input
                            value={password}
                            onChange={(e) => setPassword(e.target.value)}
                            type="text"
                            required
                        />
                        <span></span>
                        <label>Password</label>

                            </div>
                            
                            {/* <div  className="txt_field">

                                    <input
                                            value={password}
                                            onChange={(e) => setPassword(e.target.value)}
                                            type="password"
                                            // placeholder="Password"
                                            required
                                        />

                                    <span></span>
                                    <label>Password</label>

                            </div> */}

                            
                            {Loading ?<div>
                               
                                <BeatLoader color="#36d7b7" />
                            </div> :    
                            <>
                            <input type="submit" value="Sign Up" />
                           
                                
                                {successMsg && <div className="successMsgContainer">
                                            
                                            <p>{`Operation successfull! ${Msg}`}</p>
                                            
                                </div>}
                                {errorMsg && <div className="errorMsgContainer">
                                            
                                            <p>{`Operation Failed! ${Msg}`}</p>
                                            
                                </div>}
                                

                                <div className="signup_link">
                                Already a member? <a href="#" onClick={handleAuthForm}>Sign in </a>
                                </div>
                            
                            </>}
                                
                            
                            
                        </form>

                </>}
			
		</div>
      


        </>
    )

}

export default Login;